import { cn } from "@/lib/utils"

/** mkt-chip with the emphasis/outline choice made once instead of ~10 ternaries. */
export function Chip({
  emphasis = false,
  className,
  children,
}: {
  emphasis?: boolean
  className?: string
  children: React.ReactNode
}) {
  return (
    <span
      className={cn("mkt-chip", !emphasis && "mkt-chip--outline", className)}
    >
      {children}
    </span>
  )
}

/**
 * Skill/tag chip list with the standard truncation + "+N" overflow chip.
 * Pass `max` to cap what's shown; the overflow chip appears automatically.
 */
export function TagChips({
  items,
  max,
}: {
  items: string[]
  max?: number
}) {
  const shown = max ? items.slice(0, max) : items
  const extra = items.length - shown.length
  return (
    <>
      {shown.map((item, index) => (
        // Skills/facts come from free-text comma lists — duplicates are
        // possible, so the value alone isn't a stable key.
        <Chip key={`${item}-${index}`}>{item}</Chip>
      ))}
      {extra > 0 && <Chip>+{extra}</Chip>}
    </>
  )
}
